import styled from 'styled-components';
import IconArrowDownCircle from './IconArrowDownCircle';
var IconArrowUpCircle = /*#__PURE__*/styled(IconArrowDownCircle).withConfig({
  displayName: "IconArrowUpCircle",
  componentId: "c11n-8-111-1__sc-1h3m26u-0"
})(["transform:rotate(180deg);"]);
export default IconArrowUpCircle;